window.addEventListener('load', function () {
    const mainHeader = document.querySelector('.main-header')
    var headerHeight = mainHeader.clientHeight
    
    // Fixed header functionality
    window.onscroll = function(e) {
        if(!mainHeader.classList.contains('main-header--multiple')){
            if (this.oldScroll < this.scrollY) {
                // Downscroll code
                if (window.scrollY > headerHeight){
                    // Fix the header
                    mainHeader.classList.add('main-header--fixed')
                    mainHeader.style.top = `-${headerHeight}px`
                    document.body.style.paddingTop = `${headerHeight}px`
                }
            } else {
                // Upscroll code
                if(mainHeader.classList.contains('main-header--fixed') && window.scrollY > headerHeight){
                    mainHeader.style.top = `0px`
                }
                if(mainHeader.classList.contains('main-header--fixed') && window.scrollY <= headerHeight){
                    // Make header relative again
                    mainHeader.classList.remove('main-header--fixed')
                    mainHeader.style.top = ``
                    document.body.style.paddingTop = ``
                }
            }
            this.oldScroll = this.scrollY;
        }
    }

    // Header Search
    // The search drawer do not use Bootstrap functions to open, because its auto-focus functionality conflicts with an iOS setting

    // Show header search drawer on click
    const headerSearchButtons = document.querySelectorAll(`[aria-controls="searchDrawer"]`)
    headerSearchButtons.forEach(btn => {
        btn.onclick = () => {
            showSearchDrawer()
        }
    })

    // Close search drawer by clicking the close button or backdrop
    const closeearchDrawerBtn = document.querySelectorAll(`.close-search-drawer`)
    closeearchDrawerBtn.forEach(btn => {
        btn.onclick = () => {
            closeSearchDrawer()
        }
    })

    // Close search drawer by pressing esc
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            //if esc key was not pressed in combination with ctrl or alt or shift
            const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
            if (isNotCombinedKey) {
                closeSearchDrawer()
            }
        }
    })

    // Function to show the search drawer
    function showSearchDrawer() {
        // hide menu
        const menu = document.getElementById('mobileMenu')
        if (menu.classList.contains('show')) {
            menu.classList.remove('show')
            menu.nextSibling.remove()
        }

        // show search drawer
        const searchDrawer = document.getElementById('searchDrawer')
        searchDrawer.classList.add('show')

        // Focus on input
        const searchDrawerInput = document.querySelector('#searchDrawerInput')
        searchDrawerInput.focus()
    }

    // Function do close the search drawer
    function closeSearchDrawer() {
        // Close menu
        var menuOffCanvas = new bootstrap.Offcanvas('#mobileMenu')
        menuOffCanvas.hide()

        // Close search drawer
        const searchDrawer = document.getElementById('searchDrawer')
        searchDrawer.classList.remove('show')

        // Remove body inline styles
        document.body.style.overflow = ''
        document.body.style.paddingRight = ''
    }

    initActiveMenuStates();
})

// This script retrieves the 'q' query parameter from the URL and populates 
// the search input field with its value. It replaces the backend implementation 
// in the Twig template to prevent potential issues with cached pages.
document.addEventListener('DOMContentLoaded', () => {
    const searchInput = document.getElementById('searchDrawerInput');
    if (searchInput) {
        const urlParams = new URLSearchParams(window.location.search);
        const searchValue = urlParams.get('q') || '';
        searchInput.value = searchValue;
    }
});

/**
 * Sets active classes on menu items based on the current URL
 */
function initActiveMenuStates() {
    const currentUrl = window.location.href;
    
    // Function to check if a URL matches the current page
    function isCurrentUrl(menuUrl) {
        // Simple exact match comparison
        return currentUrl === menuUrl;
    }
    
    // Process desktop menu items
    document.querySelectorAll('.main-header__menu-button[data-url]').forEach(menuItem => {
        const menuUrl = menuItem.getAttribute('data-url');
        
        if (isCurrentUrl(menuUrl)) {
            menuItem.classList.add('main-header__menu-button--active');
        }
    });
    
    // Process mobile menu items
    document.querySelectorAll('.menu-accordion__button[data-url]').forEach(menuItem => {
        const menuUrl = menuItem.getAttribute('data-url');
        
        if (isCurrentUrl(menuUrl)) {
            menuItem.classList.add('active');
        }
    });
    
    // Process dropdown items and set active states
    let activeMenuIds = new Set();
    
    document.querySelectorAll('.dropdown-item[data-url], .accordion-body a[data-url]').forEach(subMenuItem => {
        const menuUrl = subMenuItem.getAttribute('data-url');
        const itemId = subMenuItem.getAttribute('data-item-id');
        const parentMenuId = subMenuItem.getAttribute('data-parent-menu-id');
        
        if (isCurrentUrl(menuUrl)) {
            // Mark this dropdown item as active
            subMenuItem.classList.add('dropdown-item--active');
            
            // If we have a parent menu ID, collect it for parent menu activation
            if (parentMenuId) {
                activeMenuIds.add(parentMenuId);
                
                // Find parent accordion item and expand it (mobile view)
                const parentCollapse = subMenuItem.closest('.accordion-collapse');
                if (parentCollapse) {
                    parentCollapse.classList.add('show');
                    
                    // Find and update the associated button
                    const accordionButton = document.querySelector(`[data-bs-target="#${parentCollapse.id}"]`);
                    if (accordionButton) {
                        accordionButton.classList.add('active');
                        accordionButton.setAttribute('aria-expanded', 'true');
                    }
                }
            }
        }
    });
    
    // Set active state on parent dropdown buttons if they contain active items
    if (activeMenuIds.size > 0) {
        activeMenuIds.forEach(id => {
            // For desktop dropdown menus
            const dropdownButton = document.querySelector(`.main-header__menu-button[data-menu-id="${id}"]`);
            if (dropdownButton) {
                dropdownButton.classList.add('main-header__menu-button--active');
            }
            
            // For mobile accordion menus
            const accordionButton = document.querySelector(`.menu-accordion__button[data-menu-id="${id}"]`);
            if (accordionButton) {
                accordionButton.classList.add('active');
            }
        });
    }
}
